var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBillable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M19.477 19.46V2H4.523v17.507L6.443 22l1.381-1.952 1.377 1.948 1.392-1.94 1.369 1.94 1.392-1.94 1.368 1.94 1.403-1.952L17.51 22zm-5.125-6.683q-.822.947-2.02.947-.754 0-1.348-.342a2.33 2.33 0 0 1-.913-.948h2.888v-.959H9.785a3 3 0 0 1-.011-.308q0-.205.011-.309h3.174V9.9h-2.888a2.33 2.33 0 0 1 .913-.947 2.65 2.65 0 0 1 1.347-.343q1.188 0 2.021.936l1.176-1.096a3.75 3.75 0 0 0-1.415-1.05q-.834-.366-1.873-.366-.993 0-1.85.354a4 4 0 0 0-1.438 1.005A3.9 3.9 0 0 0 8.095 9.9h-1.29v.96h1.119a3 3 0 0 0-.011.308q0 .206.011.308H6.805v.96h1.29q.262.855.857 1.506.593.652 1.438 1.005.857.354 1.85.354 1.04 0 1.873-.365a3.7 3.7 0 0 0 1.415-1.062z",
  clipRule: "evenodd"
})));
export default SvgBillable;